import { render } from "./TheAlert.vue?vue&type=template&id=04c0002d&scoped=true"
import script from "./TheAlert.vue?vue&type=script&lang=js"
export * from "./TheAlert.vue?vue&type=script&lang=js"

import "./TheAlert.vue?vue&type=style&index=0&id=04c0002d&scoped=true&lang=css"

import exportComponent from "/home/emrdev/Project/work/sibugol_dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c0002d"]])

export default __exports__